const WhoThisIsFor = () => {
  const audiences = [
    { icon: 'ri-briefcase-line', title: 'Business Credit Brokers', description: 'Scale your existing broker business with wholesale access' },
    { icon: 'ri-money-dollar-circle-line', title: 'Loan Brokers', description: 'Add business credit services to your offerings' },
    { icon: 'ri-funds-line', title: 'Funding Consultants', description: 'Expand your service portfolio with credit building' },
    { icon: 'ri-shield-check-line', title: 'Credit Repair Companies', description: 'Grow into business credit with our support' },
    { icon: 'ri-rocket-line', title: 'Entrepreneurs', description: 'Build a profitable funding business from scratch' },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#2F6FE4] mb-6">Perfect For</h2>
          <div className="w-16 h-1 bg-[#3D8BFF] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border-2 border-[#A9C9FF] hover:border-[#3D8BFF] transition-all hover:scale-105 shadow-lg"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#A9C9FF] rounded-full mb-6 mx-auto">
                <i className={`${audience.icon} text-3xl text-[#2F6FE4]`}></i>
              </div>
              <h3 className="text-[#2F6FE4] text-lg font-bold mb-3 text-center">{audience.title}</h3>
              <p className="text-[#555555] text-sm text-center leading-relaxed">{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;